const mobile_menu_checkbox = document.getElementById('mobile-menu-checkbox');

mobile_menu_checkbox.addEventListener('change', (event) => {
    if(event.target.checked) {
        document.body.className += ' no-scroll'
    } else {
        document.body.classList.remove("no-scroll");
  }
})
